import { Api } from '@/api/api';
import { BlankDataFieldsPostCallRequestFilters } from '@/api/requests/exception-reports/blank-data-fields-post-call-request-filters';
import { CallbacksOverdueRequestFilters } from '@/api/requests/exception-reports/callbacks-overdue-request-filters';
import { CancellationReasonsRequestFilters } from '@/api/requests/exception-reports/cancellation-reasons-request-filters';
import { ClientsConsideringOptionsRequestFilters } from '@/api/requests/exception-reports/clients-considering-options-request-filters';
import { InstructedClearedVariancesRequestFilters } from '@/api/requests/exception-reports/instructed-cleared-variances-request-filters';
import { MonitorAppointmentBookingsRequestFilters } from '@/api/requests/exception-reports/monitor-appointment-bookings-request-filters';
import { NoLongerProceedingClientsRequestFilters } from '@/api/requests/exception-reports/no-longer-proceeding-clients-request-filters';
import { NonInstructionReasonsRequestFilters } from '@/api/requests/exception-reports/non-instruction-reasons-request-filters';
import { OutstandingAppointmentOutcomesRequestFilters } from '@/api/requests/exception-reports/outstanding-appointment-outcomes-request-filters';
import { OutstandingPaymentsRequestFilters } from '@/api/requests/exception-reports/outstanding-payments-request-filters';
import { OutstandingSigningsRequestFilters } from '@/api/requests/exception-reports/outstanding-signings-request-filters';
import { TasksOverdueRequestFilters } from '@/api/requests/exception-reports/tasks-overdue-request-filters';
import { TasksUnassignedRequestFilters } from '@/api/requests/exception-reports/tasks-unassigned-request-filters';
import { UserReportRequestFilters } from '@/api/requests/exception-reports/user-report-request-filters';
import { BlankDataFieldsPostCall } from '@/shared/exception-reports/blank-data-fields-post-call';
import { CallbacksOverdue } from '@/shared/exception-reports/callbacks-overdue';
import { CancellationReasons } from '@/shared/exception-reports/cancellation-reasons';
import { ClientsConsideringOptions } from '@/shared/exception-reports/clients-considering-options';
import { InstructedClearedVariances } from '@/shared/exception-reports/instructed-cleared-variances';
import { MonitorAppointmentBookings } from '@/shared/exception-reports/monitor-appointment-bookings';
import { NoLongerProceedingClients } from '@/shared/exception-reports/no-longer-proceeding-clients';
import { NonInstructionReasons } from '@/shared/exception-reports/non-instruction-reasons';
import { OutstandingAppointmentOutcomes } from '@/shared/exception-reports/outstanding-appointment-outcomes';
import { OutstandingPayments } from '@/shared/exception-reports/outstanding-payments';
import { OutstandingSignings } from '@/shared/exception-reports/outstanding-signings';
import { TasksOverdue } from '@/shared/exception-reports/tasks-overdue';
import { TasksUnassigned } from '@/shared/exception-reports/tasks-unassigned';
import { UserReport } from '@/shared/exception-reports/user-report';

export class ExceptionReportApi extends Api {

    public async getClientsConsideringOptionsAsync(request: ClientsConsideringOptionsRequestFilters): Promise<Array<ClientsConsideringOptions>> {
        return await this.getAsync<Array<ClientsConsideringOptions>>(`v1/exceptionReport/clientsConsideringOptions`, request);
    }

    public async getClientsConsideringOptionsExportAsync(request: ClientsConsideringOptionsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/clientsConsideringOptions/export`, request);
    }

    public async getOutstandingSigningsAsync(request: OutstandingSigningsRequestFilters): Promise<Array<OutstandingSignings>> {
        return await this.getAsync<Array<OutstandingSignings>>(`v1/exceptionReport/outstandingSignings`, request);
    }

    public async getOutstandingSigningsExportAsync(request: OutstandingSigningsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/outstandingSignings/export`, request);
    }

    public async getOutstandingPaymentsAsync(request: OutstandingPaymentsRequestFilters): Promise<Array<OutstandingPayments>> {
        return await this.getAsync<Array<OutstandingPayments>>(`v1/exceptionReport/outstandingPayments`, request);
    }

    public async getOutstandingPaymentsExportAsync(request: OutstandingPaymentsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/outstandingPayments/export`, request);
    }

    public async getNonInstructionReasonsAsync(request: NonInstructionReasonsRequestFilters): Promise<Array<NonInstructionReasons>> {
        return await this.getAsync<Array<NonInstructionReasons>>(`v1/exceptionReport/nonInstructionReasons`, request);
    }

    public async getNonInstructionReasonsExportAsync(request: NonInstructionReasonsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/nonInstructionReasons/export`, request);
    }

    public async getNoLongerProceedingClientsAsync(request: NoLongerProceedingClientsRequestFilters): Promise<Array<NoLongerProceedingClients>> {
        return await this.getAsync<Array<NoLongerProceedingClients>>(`v1/exceptionReport/noLongerProceedingClients`, request);
    }

    public async getNoLongerProceedingClientsExportAsync(request: NoLongerProceedingClientsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/noLongerProceedingClients/export`, request);
    }

    public async getInstructedClearedVariancesAsync(request: InstructedClearedVariancesRequestFilters): Promise<Array<InstructedClearedVariances>> {
        return await this.getAsync<Array<InstructedClearedVariances>>(`v1/exceptionReport/instructedClearedVariances`, request);
    }

    public async getInstructedClearedVarianceExportAsync(request: InstructedClearedVariancesRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/instructedClearedVariances/export`, request);
    }

    public async getCancellationReasonsAsync(request: CancellationReasonsRequestFilters): Promise<Array<CancellationReasons>> {
        return await this.getAsync<Array<CancellationReasons>>(`v1/exceptionReport/cancellationReasons`, request);
    }

    public async getCancellationReasonsExportAsync(request: CancellationReasonsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/cancellationReasons/export`, request);
    }

    public async getOutstandingAppointmentOutcomesAsync(request: OutstandingAppointmentOutcomesRequestFilters): Promise<Array<OutstandingAppointmentOutcomes>> {
        return await this.getAsync<Array<OutstandingAppointmentOutcomes>>(`v1/exceptionReport/outstandingAppointmentOutcomes`, request);
    }

    public async getOutstandingAppointmentOutcomesExportAsync(request: OutstandingAppointmentOutcomesRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/outstandingAppointmentOutcomes/export`, request);
    }

    public async getBlankDataFieldsPostCallAsync(request: BlankDataFieldsPostCallRequestFilters): Promise<Array<BlankDataFieldsPostCall>> {
        return await this.getAsync<Array<BlankDataFieldsPostCall>>(`v1/exceptionReport/blankDataFieldsPostCall`, request);
    }

    public async getBlankDataFieldsPostCallExportAsync(request: BlankDataFieldsPostCallRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/blankDataFieldsPostCall/export`, request);
    }

    public async getUserReportAsync(request: UserReportRequestFilters): Promise<Array<UserReport>> {
        return await this.getAsync<Array<UserReport>>(`v1/exceptionReport/userReport`, request);
    }

    public async getUserReportExportAsync(request: UserReportRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/userReport/export`, request);
    }

    public async getTasksOverdueAsync(request: TasksOverdueRequestFilters): Promise<Array<TasksOverdue>> {
        return await this.getAsync<Array<TasksOverdue>>(`v1/exceptionReport/tasksOverdue`, request);
    }

    public async getTasksOverdueExportAsync(request: TasksOverdueRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/tasksOverdue/export`, request);
    }

    public async getTasksUnassignedAsync(request: TasksUnassignedRequestFilters): Promise<Array<TasksUnassigned>> {
        return await this.getAsync<Array<TasksUnassigned>>(`v1/exceptionReport/tasksUnassigned`, request);
    }

    public async getTasksUnassignedExportAsync(request: TasksUnassignedRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/tasksUnassigned/export`, request);
    }

    public async getCallbacksOverdueAsync(request: CallbacksOverdueRequestFilters): Promise<Array<CallbacksOverdue>> {
        return await this.getAsync<Array<CallbacksOverdue>>(`v1/exceptionReport/callbacksOverdue`, request);
    }

    public async getCallbacksOverdueExportAsync(request: CallbacksOverdueRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/callbacksOverdue/export`, request);
    }

    public async getMonitorAppointmentBookingsAsync(request: MonitorAppointmentBookingsRequestFilters): Promise<Array<MonitorAppointmentBookings>> {
        return await this.getAsync<Array<MonitorAppointmentBookings>>(`v1/exceptionReport/monitorAppointmentBookings`, request);
    }

    public async getMonitorAppointmentBookingsExportAsync(request: MonitorAppointmentBookingsRequestFilters): Promise<string> {
        return await this.getFileAsync(`v1/exceptionReport/monitorAppointmentBookings/export`, request);
    }

    public constructor() {
        super();
    }
}
